import React from "react";
import "./JoinToday.css";
function JoinToday() {
  return (
    <React.Fragment>
      <div className="JoinTodayWrapper">
        <div className="JoinTodayGreenBlock">
          <div className="JoinTodayGreenBlockContent">
            Sounds like we are building something cool ?
          </div>
          <a
            href="https://bit.ly/3ISpGK7"
            style={{ color: "white", textDecoration: "none" }}
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="JoinTodayGreenBlockBtn">Join us today</button>
          </a>
        </div>
      </div>
    </React.Fragment>
  );
}

export default JoinToday;
